export const formatYears = (value: number | string): string => {
  const years = typeof value === 'string' ? Number.parseInt(value, 10) : value;

  return `${years} Jahr${years > 1 ? 'e' : ''}`;
};
